import AssetPackEditor from './AssetPackEditor'

export default AssetPackEditor
